import { Link, useNavigate } from "react-router-dom";
import logo from '../assets/images/Logo.svg';
import footer_logo from '../assets/images/footer_logo.png';
import globe from '../assets/images/globe.svg';
import lightmode from '../assets/images/lightmode.svg';
import darkmode from '../assets/images/dark.svg';
import location from '../assets/images/location.svg';
import call from '../assets/images/call.svg';
import sms from '../assets/images/sms.svg';
import developed_by from '../assets/images/developed_by.png';
import fb from '../assets/images/fb.svg';
import twitter from '../assets/images/twitter.svg';
import insta from '../assets/images/insta.svg';
import linked from '../assets/images/linked.svg';
import en from '../assets/images/en.png';
import hindi from '../assets/images/hindi.png';
import profile from '../assets/images/profile.png';
import userimg from '../assets/images/userimg.png';
import exitimg from '../assets/images/exit.png';
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getprofile, logout } from "../slices/user";

import { useDispatch, useSelector } from "react-redux";

const Layout = ({ children }) => {

    const { isLoggedIn } = useSelector((state) => state.auth);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [activeMenu, setActiveMenu] = useState(0);

    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    const [activeLang, setActiveLang] = useState(currentLang);

    let sitemode = localStorage.getItem('siteMode') ? localStorage.getItem('siteMode') : 'dark-theme';
    const [currentMode, setCurrentMode] = useState(sitemode);

    const { t, i18n } = useTranslation();

    const handleMenuClick = (e) => {
        setActiveMenu(window.location.pathname);
    }
    const changeSiteMode = () => {
        sitemode = localStorage.getItem('siteMode') ? localStorage.getItem('siteMode') : 'dark-theme';
        sitemode = sitemode == "dark-theme" ? "light-theme" : "dark-theme";
        localStorage.setItem("siteMode", sitemode);
        setCurrentMode(sitemode);
    }
    const changeLanguageHandler = (languageValue) => {
        i18n.changeLanguage(languageValue);
        localStorage.setItem('activeLanguage', languageValue);
        setActiveLang(languageValue);
        window.location.reload();
    }

    const handleLogout = () => {
        dispatch(logout());
        navigate('/login');
    }
    useEffect(() => {
        let container = document.getElementById("heading_title");
        if (container) {
            let spans = container.getElementsByTagName("span");

            let phrase = spans[0];
            const words = phrase.innerHTML.split(' ');
            let len = words.length - 1;
            words[len] = `<span class='font-color-2'>${words[len]}</span>`; // this would return the second word
            phrase.innerHTML = words.join(' ');
        }
    }, [])
    useEffect(() => {
        handleMenuClick();
    });
    useEffect(() => {
        if (isLoggedIn) {
            dispatch(getprofile());
        }
    }, [isLoggedIn]);


    // handleMenuClick();
    return (
        <div className={currentMode} id="main-container">
            <header>
                <nav className="navbar navbar-expand-lg navbar-light bg-color navbar-border">
                    <div className="container-xl">
                        <Link className="navbar-brand" to="/"><img src={logo} /></Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-main">
                                <li className="nav-item">
                                    <Link className={`nav-link ${activeMenu == "/" ? "active" : ""}`} to="/">{t('home')}</Link>
                                </li>
                                {
                                    isLoggedIn ?
                                        <>
                                            <li className="nav-item dropdown">
                                                <a className={`nav-link dropdown-toggle ${activeMenu == "/advertisement" || activeMenu == "/my-advertisement" ? "active" : ""}`} href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {t('advertisements')}
                                                    <i className="fa fa-angle-down ms-1"></i>
                                                </a>
                                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                    <li><Link className="dropdown-item" to="/advertisement">{t('all_advertisements')}</Link></li>
                                                    <li><Link className="dropdown-item" to="/my-advertisement">{t('my_advertisements')}</Link></li>
                                                </ul>
                                            </li>
                                            <li className="nav-item dropdown">
                                                <a className={`nav-link dropdown-toggle ${activeMenu == "/posts" || activeMenu == "/my-posts" ? "active" : ""}`} href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {t('post')}
                                                    <i className="fa fa-angle-down ms-1"></i>
                                                </a>
                                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                    <li><Link className="dropdown-item" to="/posts">{t('all_posts')}</Link></li>
                                                    <li><Link className="dropdown-item" to="/my-posts">{t('my_posts')}</Link></li>
                                                </ul>
                                            </li>
                                            <li className="nav-item dropdown">
                                                <a className={`nav-link dropdown-toggle ${activeMenu == "/jobs" || activeMenu == "/my-jobs" ? "active" : ""}`} href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    {t('job')}
                                                    <i className="fa fa-angle-down ms-1"></i>
                                                </a>
                                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                    <li><Link className="dropdown-item" to="/jobs">{t('all_jobs')}</Link></li>
                                                    <li><Link className="dropdown-item" to="/my-jobs">{t('my_jobs')}</Link></li>
                                                </ul>
                                            </li>

                                            <li className="nav-item">
                                                <Link className={`nav-link ${activeMenu == "/gallery" ? "active" : ""}`} to="/gallery">{t('gallery')}</Link>
                                            </li>
                                            <li className="nav-item">
                                                <Link className={`nav-link ${activeMenu == "/members" ? "active" : ""}`} to="/members">{t('members')}</Link>
                                            </li>
                                        </>
                                        :
                                        <li className="nav-item">
                                            <Link className={`nav-link ${activeMenu == "/gallery" ? "active" : ""}`} to="/gallery">{t('gallery')}</Link>
                                        </li>
                                }
                                <li className="nav-item">
                                    <Link className={`nav-link ${activeMenu == "/about" ? "active" : ""}`} to="/about">{t('about')}</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className={`nav-link ${activeMenu == "/contact" ? "active" : ""}`} to="/contact" >{t('contact')}</Link>
                                </li>
                            </ul>
                            <ul className="navbar-nav mb-2 mb-lg-0 d-flex navbar-right-item">
                                <li className="nav-item dropdown item-list">
                                    <a className="nav-link dropdown-toggle text-uppercase" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ alignItems: 'center' }}>
                                        <img src={globe} className="me-2 langImg" />
                                        {activeLang}
                                        <i className="fa fa-angle-down ms-1"></i>
                                    </a>
                                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <li><a className={`dropdown-item mt-2 me-5 ${activeLang == "en" ? "active_lng" : ""}`} href="#" onClick={e => changeLanguageHandler('en')}><img src={en} /> English</a></li>
                                        <li><a className={`dropdown-item ${activeLang == "hi" ? "active_lng" : ""}`} href="#" onClick={e => changeLanguageHandler('hi')}><img src={hindi} /> हिंदी</a></li>
                                    </ul>
                                </li>
                                <li className="nav-item dropdown item-list">
                                    <a className="nav-link swichMode" href="#" onClick={() => changeSiteMode()}>
                                        {
                                            currentMode == "dark-theme" ?
                                                <img src={lightmode} width={25} />
                                                :
                                                <img src={darkmode} width={25} />
                                        }
                                    </a>
                                </li>
                                {
                                    isLoggedIn ?
                                        <li className="nav-item dropdown item-list">
                                            <a className="nav-link dropdown-toggle profileIcon" href="#" id="navbarDropdown1" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ alignItems: 'center', padding: 0 + " !important" }}>
                                                <img src={profile} width={25} />
                                            </a>
                                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown1">
                                                <li><Link to="/profile" className="dropdown-item mt-2 me-5" href="#"><img src={userimg} />{t('profile')}</Link></li>
                                                <li><a className="dropdown-item active_lng" href="#" onClick={e => handleLogout()}><img src={exitimg} /> {t('logout')}</a></li>
                                            </ul>
                                        </li>
                                        :
                                        <li className="nav-item dropdown item-btn">
                                            <Link className="nav-link" to="/login">
                                                &nbsp; {t('login_register')} &nbsp;
                                            </Link>
                                        </li>
                                }
                            </ul>
                        </div>
                    </div>
                </nav>
            </header>
            <main className="pb-5">
                {children}
            </main>
            <footer className="bg-2 mt-5">
                <div className="container footer">
                    <div className="row">
                        <div className="col-md-4 mb-4">
                            <img src={footer_logo} />
                        </div>
                        <div className="col-md-1"></div>
                        <div className="col-md-2">
                            <h5>{t('company')}</h5>
                            <ul>
                                <li>
                                    <Link className="nav-link" to="/" >{t('home')}</Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to="/gallery" >{t('gallery')}</Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to="/about" >{t('about')}</Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to="/contact" >{t('contact')}</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-2">
                            <h5>{t('services')}</h5>
                            <ul>
                                <li>
                                    <Link className="nav-link" to="/advertisement" >{t('advertisements')}</Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to="/posts" >{t('post')}</Link>
                                </li>
                                <li>
                                    <Link className="nav-link" to="/jobs" >{t('job')}</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-3">
                            <h5>{t('contact')}</h5>
                            <ul>
                                <li className="pb-2 d-flex footer_address">
                                    <img src={location} className="me-2" /><span className="p-0" > Building, Street, City, Country</span>
                                </li>
                                <li>
                                    <span className="" ><img src={call} className="me-2" /> 1234567890</span>
                                </li>
                                <li>
                                    <span className=""><img src={sms} className="me-2" /> info@sjs.com</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row footer-2">
                        <div className="col-md-6">
                            <span className="pe-3 reserved_by">
                                © 2023 All Rights Reserved
                            </span>
                            <span className="ps-3">
                                Developed by <Link to="http://calidig.com" target="_blank"><img src={developed_by} className="ms-2" /></Link>
                            </span>
                        </div>
                        <div className="col-md-6">
                            <ul className="social-links">
                                <li><Link><img src={fb} /></Link></li>
                                <li><Link><img src={twitter} /></Link></li>
                                <li><Link><img src={linked} /></Link></li>
                                <li><Link><img src={insta} /></Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </footer>
        </div>
    );
}

export default Layout;